/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Save_3Inputs */

const en_pc_tut_save_3 = /** @type {(inputs: Pc_Tut_Save_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If PdfCraft ever quits unexpectedly, it offers to recover your work next time.`)
};

const zh_pc_tut_save_3 = /** @type {(inputs: Pc_Tut_Save_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果 PdfCraft 意外退出，下次启动时会提示恢复你的工作。`)
};

/**
* | output |
* | --- |
* | "If PdfCraft ever quits unexpectedly, it offers to recover your work next time." |
*
* @param {Pc_Tut_Save_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_save_3 = /** @type {((inputs?: Pc_Tut_Save_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Save_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_save_3(inputs)
	return zh_pc_tut_save_3(inputs)
});
export { pc_tut_save_3 as "pc.tut.save.3" }